module.exports = __webpack_public_path__ + "static/ja-394c5346335b2e052be89ea02fc809ab.svg";